import React, { useRef, useEffect } from "react";
import styles from "./CategoryExpensesChartCategory.module.css";

import dairyLogo from "./Dairy.png";
import frozenLogo from "./Frozen.png";
import snacksLogo from "./Snacks.png";
import beveragesLogo from "./Beverages.png";
import cannedLogo from "./Canned.png";
import cleaningLogo from "./Cleaning.png";
import pharmacyLogo from "./Pharmacy.png";
import otherLogo from "./Other.png";
import bakingLogo from "./Baking.png";

const categoryIcons = {
  "מוצרי חלב וביצים": dairyLogo,
  "מוצרים קפואים": frozenLogo,
  "חטיפים, מתוקים ודגנים": snacksLogo,
  "משקאות, יין ואלכוהול": beveragesLogo,
  "שימורים": cannedLogo,
  "ניקיון וחד פעמי": cleaningLogo,
  "פארם ותינוקות": pharmacyLogo,
  "בישול ואפייה": bakingLogo,
  Other: otherLogo,
};

function getCategoryIcon(category) {
  return categoryIcons[category] || otherLogo;
}




const CategoryExpensesChartCategory = ({
  name,
  value,
  color,
  isSelected,
  onClick,
  containerRef, // מקבל את הרפרנס לקונטיינר מהרכיב האב
}) => {
  // רפרנס לאלמנט של האייטם עצמו
  const itemRef = useRef(null);

  useEffect(() => {
    if (isSelected && containerRef.current && itemRef.current) {
      const containerEl = containerRef.current;
      const itemEl = itemRef.current;

      // נקבל את "מלבן" הקונטיינר והאייטם
      const containerRect = containerEl.getBoundingClientRect();
      const itemRect = itemEl.getBoundingClientRect();

      // מחשבים את המיקום האנכי של האייטם ביחס לראש הקונטיינר
      // offsetTopWithinContainer = מיקום רלוונטי לגלילה
      let offsetTopWithinContainer =
        itemRect.top - containerRect.top + containerEl.scrollTop;

      // נניח שאתה רוצה שהאייטם יהיה קצת מתחת לשוליים העליונים (למשל 5 פיקסלים רווח):
      offsetTopWithinContainer -= 5;

      // כדי למנוע גלילה "מעבר" לתחתית:
      const maxScroll = containerEl.scrollHeight - containerEl.clientHeight;
      if (offsetTopWithinContainer > maxScroll) {
        offsetTopWithinContainer = maxScroll;
      }
      // וכדי למנוע גלילה שלילית, אם זה קורה איכשהו:
      if (offsetTopWithinContainer < 0) {
        offsetTopWithinContainer = 0;
      }

      // מבצעים את הגלילה
      containerEl.scrollTo({
        top: offsetTopWithinContainer,
        behavior: "smooth",
      });
    }
  }, [isSelected, containerRef]);

  return (
    <div
      ref={itemRef} // מצמידים את הרפרנס
      className={`${styles['category-list-item']} ${isSelected ? styles.selected : ""}`}
      onClick={onClick}
      style={{ borderColor: color }}
    >
      <div className={styles['category-list-item-content']}>
        <div className={styles['category-list-item-content_name']}>{name}</div>
        <div className={styles['category-list-item-content_value']}>
          ₪{value.toFixed(2)}
        </div>
      </div>
      <div className={styles['category-list-item-image']}>
        <img src={getCategoryIcon(name)} 
         alt={name} />
      </div>
    </div>
  );
};

export default CategoryExpensesChartCategory;
